import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "pageCount", "currentPage", "getPageLink", "isLoading", "emptyContent", "stickyHeaderOffset", "mobileViewBreakpoint"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Landmark from 'components/Landmark';
import Card from 'components/Card';
import StickyBox from 'components/StickyBox';
import Table, { Column } from 'components/Table';
import Pagination from 'components/Pagination';
import { borderValue } from 'styles/mixins';
import { getSolidBackgroundShade, pxToRem } from 'utils/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var tableRowHeight = 62;
var PaginationWrapper = styled(StickyBox).withConfig({
  displayName: "TableCard__PaginationWrapper",
  componentId: "sc-gudhjo-0"
})(["display:flex;align-items:center;min-height:", ";padding:", " ", ";background-color:", ";border-top:", ";border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;@media (max-width:", ") and (max-height:580px){position:relative !important;}"], pxToRem(tableRowHeight), function (p) {
  return p.theme.globals.spacing.s;
}, function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return getSolidBackgroundShade(p.theme);
}, function (p) {
  return borderValue(p.theme);
}, function (p) {
  return p.theme.globals.breakpoints.xs;
});
function TableCard(_ref) {
  var children = _ref.children,
    pageCount = _ref.pageCount,
    currentPage = _ref.currentPage,
    getPageLink = _ref.getPageLink,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    emptyContent = _ref.emptyContent,
    stickyHeaderOffset = _ref.stickyHeaderOffset,
    mobileViewBreakpoint = _ref.mobileViewBreakpoint,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Card, {
    overflow: "visible",
    children: [/*#__PURE__*/_jsx(Table, _objectSpread(_objectSpread({}, otherProps), {}, {
      emptyContent: isLoading ? /*#__PURE__*/_jsx(Landmark, {
        icon: "spinner",
        height: 250,
        children: t('loading')
      }) : emptyContent,
      shadedHeader: true,
      rowMinHeight: tableRowHeight,
      stickyHeaderOffset: stickyHeaderOffset,
      mobileViewBreakpoint: mobileViewBreakpoint,
      children: children
    })), /*#__PURE__*/_jsx(PaginationWrapper, {
      placement: "bottom",
      children: /*#__PURE__*/_jsx(Pagination, {
        pageCount: pageCount,
        currentPage: currentPage,
        getPageLink: getPageLink,
        desktopViewBreakpoint: mobileViewBreakpoint
      })
    })]
  });
}
export { Column };
export default TableCard;